
    <div>
      <span class="password-strength" [ngClass]="strengthLabel">
        {{ strengthLabel | ucfirst }}
      </span>
    </div>
  